import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { X, Printer } from "lucide-react";

// Printable AusPost-style shipping label. Sender comes from admin settings (street hidden when configured).
export function ShippingLabel({ order, shipping, onClose }) {
  const barcodeRef = useRef(null);
  const code = order.tracking_number || order.id.replace(/-/g, "").slice(0, 16).toUpperCase();

  useEffect(() => {
    if (barcodeRef.current) {
      try {
        JsBarcode(barcodeRef.current, code, { format: "CODE128", height: 64, width: 2, displayValue: true, fontSize: 14, margin: 6 });
      } catch {}
    }
  }, [code]);

  const s = shipping || {};
  const cust = order.customer || {};
  const addr = cust.address || {};
  const senderLines = [
    s.sender_name || "Aura Glow Wellness",
    !s.hide_street && s.sender_line1 ? s.sender_line1 : null,
    `${s.sender_suburb || "Biggera Waters"} ${s.sender_state || "QLD"} ${s.sender_postcode || "4216"}`,
    "AUSTRALIA",
  ].filter(Boolean);

  return (
    <div data-testid="shipping-label-modal" className="fixed inset-0 z-[140] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm print:bg-white print:p-0" onClick={onClose}>
      <div className="w-full max-w-md rounded-2xl bg-white p-5 print:max-w-none print:rounded-none" onClick={(e) => e.stopPropagation()}>
        <div className="mb-4 flex items-center justify-between print:hidden">
          <h3 className="font-display text-xl text-[#2C2B2C]">Shipping Label</h3>
          <div className="flex gap-2">
            <button onClick={() => window.print()} data-testid="print-label-btn" className="flex items-center gap-1.5 rounded-full bg-[#232222] px-4 py-2 text-[0.62rem] uppercase tracking-wider text-[#F5EFE3]"><Printer className="h-3.5 w-3.5" /> Print</button>
            <button onClick={onClose} className="rounded-full p-1.5 text-[#9A8E88] hover:bg-[#FBF5F1]"><X className="h-5 w-5" /></button>
          </div>
        </div>

        <div id="ship-label" className="border-2 border-black p-5 text-black">
          <div className="flex items-center justify-between border-b-2 border-black pb-2">
            <span className="text-sm font-bold uppercase tracking-wide">Australia Post</span>
            <span className="text-xs font-semibold uppercase">Express Post</span>
          </div>

          <div className="mt-3">
            <p className="text-[0.6rem] font-bold uppercase tracking-wider text-black/60">From</p>
            {senderLines.map((l, i) => (
              <p key={i} className={`text-[0.72rem] leading-tight ${i === 0 ? "font-bold" : ""}`}>{l}</p>
            ))}
          </div>

          <div className="mt-4 border-t border-black/30 pt-3">
            <p className="text-[0.6rem] font-bold uppercase tracking-wider text-black/60">Deliver To</p>
            <p className="text-base font-bold leading-tight">{cust.name || order.email}</p>
            {addr.line2 && <p className="text-sm leading-tight">{addr.line2}</p>}
            <p className="text-sm leading-tight">{addr.line1}</p>
            <p className="text-sm font-semibold leading-tight">{addr.suburb} {addr.state} {addr.postcode}</p>
            <p className="text-sm leading-tight">AUSTRALIA</p>
            {cust.phone && <p className="mt-1 text-xs">Ph: {cust.phone}</p>}
          </div>

          <div className="mt-4 flex flex-col items-center border-t-2 border-black pt-3">
            <svg ref={barcodeRef} data-testid="label-barcode" />
            <p className="mt-1 text-[0.6rem] uppercase tracking-wider text-black/60">Order #{order.id.slice(0, 8).toUpperCase()} · {order.items?.reduce((a, i) => a + i.quantity, 0)} item(s)</p>
          </div>
        </div>
        {!order.customer && (
          <p className="mt-3 text-center text-xs text-[#FBC4A8] print:hidden">No saved address for this order (placed before checkout form). Label uses email only.</p>
        )}
      </div>
    </div>
  );
}
